const ImageResponse = ({ imageUrl }) => {
    if (!imageUrl) return null;

    return (
        <img
            src={imageUrl}
            alt="Response visual"
            className="rounded-lg mt-3 max-h-64 object-contain"
        />
    );
};

export default ImageResponse;
